import { Box, IconButton } from '@mui/material';
import dayjs from 'dayjs';
import { memo, useEffect, useState } from 'react';
import { TimelineGroupBase } from 'react-calendar-timeline';
import 'react-calendar-timeline/lib/Timeline.css';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, ArrowRightIcon } from '~/assets/icons';
import { BaseTimeline } from '~/components/common';
import { BaseTimelineDayItem } from '~/components/common/base-timeline/BaseTimeline';
import { useAppDispatch } from '~/redux/hooks';
import { handleGetJobsTimeline } from '~/thunks/job/jobThunk';
import { adminRouteAbsolute } from '~/utils/constants/route';
import { handleApiError } from '~/utils/helper';
import { IJobsTimeline } from '~/utils/interface/job';

const ProjectTimeline = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['admin/dashboard']);

  const [jobsTimeline, setJobsTimeline] = useState<Array<BaseTimelineDayItem<IJobsTimeline>>>([]);
  const [groups, setGroups] = useState<Array<TimelineGroupBase>>([]);

  const navigate = useNavigate();

  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [currentTime, setCurrentTime] = useState(dayjs());
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  useEffect(() => {
    dispatch(
      handleGetJobsTimeline({
        startDate: dayjs(currentTime).startOf('month').toDate(),
        endDate: dayjs(currentTime).endOf('month').toDate(),
      })
    )
      .unwrap()
      .then((response) => {
        const groups: Array<TimelineGroupBase> = [];
        let items = response.responses.map((item) => {
          groups.push({
            id: item.id,
            title: '',
            height: 50,
          });
          return {
            id: item.id,
            title: item.name,
            start_time: dayjs(item.startDate).startOf('day'),
            end_time: dayjs(item.endDate).endOf('day'),
            group: item.id,
            style: { borderLeft: `3px solid ${item.color}`, borderRadius: '6px' },
          };
        });
        setGroups(groups);
        setJobsTimeline(items as any as Array<BaseTimelineDayItem<IJobsTimeline>>);
      })
      .catch((e) => {
        handleApiError(e);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, currentTime]);

  return (
    <Box>
      <Box className='flex justify-between mb-[16px]'>
        <Box className='text-[#040C2C] font-[500] text-[18px] leading-[26px]'>{t('projectTimeline')}</Box>
        <Box className='flex flex-row justify-between border border-[#E5EAEF] rounded-[8px] h-[31px] min-w-[130px]'>
          <IconButton
            className='hover:bg-[unset]'
            onClick={() => setCurrentTime(currentTime.clone().subtract(1, 'month'))}
          >
            <ArrowLeftIcon className='w-[13px] h-[13px] stroke-[#797D8A]' />
          </IconButton>
          <Box className='text-[#797D8A] leading-[31px] '>{currentTime.format('MMM YYYY')}</Box>
          <IconButton className='hover:bg-[unset]' onClick={() => setCurrentTime(currentTime.clone().add(1, 'month'))}>
            <ArrowRightIcon className='w-[13px] h-[13px] stroke-[#797D8A]' />
          </IconButton>
        </Box>
      </Box>
      <BaseTimeline<IJobsTimeline>
        currentTime={currentTime}
        unit='month'
        groups={groups}
        items={jobsTimeline}
        itemRenderer={(item) => {
          return (
            <Box
              className='flex flex-col gap-[4px] calendar-week-multiple-view'
              onClick={() => navigate(adminRouteAbsolute.jobDetail.replace(':id', String(item.id)))}
            >
              <Box className='truncate content-timeline w-full' style={item.style}>
                {item.title}
              </Box>
            </Box>
          );
        }}
      />
    </Box>
  );
};

export default memo(ProjectTimeline);
